const partnersData = [

    {
        title : "Astek",
        url: "",
        picture : "astek.webp"
    },
    {
        title : "Atos",
        url: "",
        picture : "atos.webp"
    },
    {
        title : "Axway",
        url: "",
        picture : "axway.webp"
    },
    {
        title : "Capgemini",
        url: "",
        picture : "capgemini.webp"
    },
    {
        title : "Cimpa",
        url: "",
        picture : "cimpa.webp"
    },
    {
        title : "CS Group",
        url: "",
        picture : "csgroup.webp"
    },
    {
        title : "Dassault",
        url: "",
        picture : "cimpa.webp"
    },
    {
        title : "Eviden",
        url: "",
        picture : "eviden.webp"
    },
    {
        title : "Ipsen",
        url: "",
        picture : "ipsen.webp"
    },
    {
        title : "Natran",
        url: "",
        picture : "natran.webp"
    },
    {
        title : "Sopra",
        url: "",
        picture : "sopra.webp"
    },
    {
        title : "Sopra Steria",
        url: "",
        picture : "soprasteria.webp"
    },
    {
        title : "Wavestone",
        url: "",
        picture : "wavestone.webp"
    },
    {
        title : "Accenture",
        url: "",
        picture : "accenture.png"
    },
    {
        title : "Adeo",
        url: "",
        picture : "adeo.png"
    },
    {
        title : "Bnp Paribas",
        url: "",
        picture : "bnpparibas.png"
    },
    {
        title : "CA-GIP",
        url: "",
        picture : "ca-gip.png"
    },
    {
        title : "Chronodrive",
        url: "",
        picture : "chronodrive.png"
    },
    {
        title : "EDF",
        url: "",
        picture : "edf.png"
    },
    {
        title : "Enedis",
        url: "",
        picture : "enedis.png"
    },
    {
        title : "Euro Information",
        url: "",
        picture : "euro-information.png"
    },
    {
        title : "Fnac Darty",
        url: "",
        picture : "fnacdarty.png"
    },
    {
        title : "Framatome",
        url: "",
        picture : "framatome.png"
    },
    {
        title : "Google",
        url: "",
        picture : "google.png"
    },
    {
        title : "Groupe TF1",
        url: "",
        picture : "groupe-tf1.png"
    },
    {
        title : "Groupe BPCE",
        url: "",
        picture : "groupe-bpce.png"
    },
    {
        title : "HALLE-INCLUSIVE",
        url: "",
        picture : "halle-inclusive.jpg"
    },
    {
        title : "Itekway",
        url: "",
        picture : "Itekway.png"
    },
    {
        title : "LCL",
        url: "",
        picture : "lcl.jpeg"
    },
    {
        title : "Lectra",
        url: "",
        picture : "lectra.jpg"
    },
    {
        title : "Logo Squad",
        url: "",
        picture : "logo-squad.svg"
    },
    {
        title : "Neoxam",
        url: "",
        picture : "neoxam.png"
    },
    {
        title : "Omnes Education",
        url: "",
        picture : "omneseducation.jpg"
    },
    {
        title : "Sanofi",
        url: "",
        picture : "sanofi.png"
    },
    {
        title : "SG",
        url: "",
        picture : "sg.png"
    },
    {
        title : "Worldline",
        url: "",
        picture : "Worldline.png"
    }
];

export default partnersData;
